import { BllOrtak } from './../../../providers/bll/bll-ortak';
import { Component } from '@angular/core';
import { NavController, NavParams, ViewController } from 'ionic-angular';
import { Ortak } from '../../../providers/ortak';
import { elementAttribute } from '@angular/core/src/render3/instructions';
declare var cordova: any;

@Component({
  selector: 'page-borclu-hesaplar-report',
  templateUrl: 'borclu-hesaplar-report.html',
})
export class BorcluHesaplarReportPage {
  BorcluListesi = [];
  BorcluListesi2 = [];
  aranan = "";
  take: number = 5000;
  istektarihi :any;
  cihazid = "";
  musteriGrupListesi = [];
  secilengrup: number = 1;
  toplamBorc: number = 0;
  ServerParamet: any = { FirmaAdi: "", FirmaTelefonu: "", FirmaAdres: "", FirmaEmail: "", FirmaWeb: "", FirmaVD: "", FirmaVN: "" };
  constructor(public navCtrl: NavController,
    public bllOrtak: BllOrtak,
    public ortak: Ortak,
    public viewCtrl: ViewController,
    public navParams: NavParams) {
    this.bllOrtak.islemWithoutPost("ParametreleriVer", "", false).then(a => {
      var sonuc = <any>a;
      this.ServerParamet = sonuc.SonucObject;
    });
    this.cihazid = this.ortak.storageCihazBilgisiGetir.ID;
    this.istektarihi=this.ortak.storageGunTarihiGetir;
    this.istektarihi=this.ortak.tarih(this.istektarihi);
  }

  ionViewDidLoad() {
    this.GrupGetir();
    this.cariAra(null);
  }
  cariAra(e) {
    this.toplamBorc =0;

    var formData = new FormData();
    formData.append("aranan", this.aranan);
    formData.append("grupid",this.secilengrup.toString());
    formData.append("take", this.take.toString());
    this.bllOrtak.islem(formData, "BorcluCariHesaplar", "", false).then(a => {
      var sonuc = <any>a;
      this.BorcluListesi = sonuc.SonucObject;
      this.BorcluListesi.forEach(element => {
        element.Bakiyesi = element.Bakiyesi * -1;
        this.toplamBorc += element.Bakiyesi;
  
      });
  
      this.BorcluListesi2 = this.BorcluListesi.filter(a => a.Bakiyesi != 0);
    })
  }
  cariler(e) {
    if (e.keyCode == 13) {
      this.cariAra(e);
    }
  }
  GrupGetir() {
    this.bllOrtak.islemWithoutPost("CariGrupListesi", "", false).then(a => {
      var sonuc = <any>a;
      this.musteriGrupListesi = sonuc.SonucObject;
    })
  }
  pdf() {
    var html = "<html><head>  <link href='https://stackpath.bootstrapcdn.com/bootstrap/4.1.1/css/bootstrap.min.css' rel='stylesheet'></head><body>" +
      "<table style='width: 100%;border-bottom:1px solid lightgray;margin-bottom:30px'>" +
      "<tbody>" +
      "<tr>" +
      "<td style'width: 41.8357%;'>&nbsp;</td>" +
      "<td style='width: 53.1643%;'><span style='float:left;width:100%;text-align:right'> {{ServerParamet.FirmaAdres}}</span></td>" +
      "</tr>" +
      "<tr>" +
      "<td style='width: 41.8357%;'>&nbsp;<span style='color: #cc0000;'><strong style='font-size: 30px;'><strong>{{ServerParamet.FirmaAdi}}</strong></strong></span></td>" +
      "<td style='width: 53.1643%;'><span style='float:left;width:100%;text-align:right'> {{ServerParamet.FirmaTelefonu}}</span></td>" +
      "</tr>" +
      "<tr>" +
      "<td style='width: 41.8357%;'>&nbsp;</td>" +
      "<td style='width: 53.1643%;'><span style='float:left;width:100%;text-align:right'> {{ServeParamet.FirmaWeb}}</span></td>" +
      "</tr>" +
      "</tbody>" +
      "</table>" +
      "<div class='card text-center'>" +
      "<div class='card-footer text-muted'>" +
      "Borçlu Hesaplar Listesi" +
      "</div>" +
      "</div><hr/>" +
      "<table class='table table-striped table-bordered table-hover'>" +
      "<thead>" +
      "<tr>" +
      "<th>Cari Hesap Adı</th>" +
      "<th>Adres</th>" +
      "<th>Gsm</th>" +
      "<th>Borcu</th>" +
      "</tr>" +
      "</thead>" +
      "<tbody>";
    this.BorcluListesi2.forEach(extre => {
      html = html + "<tr>";
      html = html + "<td>" + extre.Definition_ + "</td>";
      html = html + "<td>" + extre.Adres + "</td>";
      html = html + "<td>" + extre.Gsm + "</td>";
      html = html + "<td>" + extre.Bakiye.toFixed(2) + "</td>";
      html = html + "</tr>";
    });
    html = html + "<table style='width:100%'>";
    html = html + "<tr>";
    html = html + "<td>";
    html = html + "<span style='float:left;width:100%;text-align:right'>Toplam Borç: " + this.toplamBorc.toFixed(2) + " </span>";
    html = html + "</td>";
    html = html + "</tr>";
    html = html + "</table>";
    html = html + "</body></html>";
    html = html + "</tbody></table></body></html>";
    cordova.plugins.pdf.htmlToPDF({
      data: html,
      documentSize: "A4",
      landscape: "portrait",
      type: "share"
    },
      (sucess) => console.log('sucess: ', sucess),
      (error) => console.log('error:', error));
  }
  excel() {
    var data = [];
    this.BorcluListesi2.forEach(element => {
      data.push({
        "Cari Hesap Adı": element.Definition_,
        "Adres": element.Addr1,
        "Gsm No": element.GsmNumber,
        "Borcu": element.Bakiyesi
      })
    });

    this.ortak.ExportExcel(data, "Borçlu Hesaplar-" + this.istektarihi).then(a => {
    }).catch(x => {
    });
  }
  kapat() {
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/Raporlars/borclu-hesaplar-report/borclu-hesaplar-report.ts